import { Controller } from "@hotwired/stimulus"

// Refresh the greeting and routine basics when a retained native Today tab becomes active.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.refresh = this.refresh.bind(this)
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
    this.handlePageShow = this.handlePageShow.bind(this)
    document.addEventListener("visibilitychange", this.handleVisibilityChange)
    document.addEventListener("app-search:reconnect", this.refresh)
    window.addEventListener("focus", this.refresh)
    window.addEventListener("pageshow", this.handlePageShow)
    window.addEventListener("routine-guidance:logged", this.refresh)
  }

  disconnect() {
    clearTimeout(this.refreshTimer)
    document.removeEventListener("visibilitychange", this.handleVisibilityChange)
    document.removeEventListener("app-search:reconnect", this.refresh)
    window.removeEventListener("focus", this.refresh)
    window.removeEventListener("pageshow", this.handlePageShow)
    window.removeEventListener("routine-guidance:logged", this.refresh)
  }

  handleVisibilityChange() {
    if (document.visibilityState === "visible") this.refresh()
  }

  handlePageShow(event) {
    if (event.persisted) this.refresh()
  }

  refresh() {
    if (!this.hasUrlValue || document.documentElement.hasAttribute("data-turbo-preview")) return

    if (this.element.querySelector("[data-staged-reveal-target=checking]:not([hidden])")) return

    clearTimeout(this.refreshTimer)
    this.refreshTimer = setTimeout(() => {
      if (this.element.hasAttribute("busy")) {
        this.refresh()
        return
      }

      const url = new URL(this.urlValue, window.location.origin).href
      if (this.element.src === url) {
        this.element.reload()
      } else {
        this.element.src = url
      }
    }, 500)
  }
}
